import React, { Component } from 'react';

class LargeHeading extends Component {

    render() {
        const Duplicates = () => {
            let duplicates = [];
            for (let i = 1; i <= (this.props.count ? this.props.count : 6); i++) {
                duplicates.push(<span key={i} className="move-me" dangerouslySetInnerHTML={{__html: this.props.title}} />);
            }
            return duplicates;
        };

        return (
            <div className="heading" {...this.props}>
                <h1 dangerouslySetInnerHTML={{__html: this.props.title}} />
                {Duplicates()}
                {this.props.children}
            </div>
        );
    }

}

export default LargeHeading;


// WEBPACK FOOTER //
// ./src/js/components/LargeHeading.js